module.exports = __webpack_public_path__ + "media/images/map_icons/WaterSports-c8fbd8384a4b0108b2183d54773bb32d.svg";